import { useState } from "react";
import { toast } from "sonner";
import { Share2 } from "lucide-react";
import { shareCard } from "../lib/shareCard";

export default function ShareFragment({ fragment, className = "" }) {
  const [busy, setBusy] = useState(false);

  const share = async () => {
    setBusy(true);
    try {
      const day = new Date(`${fragment.day}T12:00:00Z`).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
      const how = await shareCard({ text: fragment.fragment, kicker: "Fragment of the day", sub: day }, `outlaw-fragment-${fragment.day}.png`, `${fragment.fragment} \u2014 Outlaw Creative ${window.location.origin}/fragments`);
      if (how === "downloaded") toast("Card saved. Post it anywhere.");
    } catch (e) {
      if (e?.name !== "AbortError") toast("Could not make the card. Try again.");
    }
    setBusy(false);
  };

  return (
    <button onClick={share} disabled={busy} className={`inline-flex items-center gap-2 f-mono text-xs uppercase tracking-[0.2em] link-u hover:text-[var(--signal)] disabled:opacity-50 ${className}`} data-testid={`share-fragment-${fragment.day}`}>
      <Share2 size={13} /> {busy ? "Cutting card\u2026" : "Share card"}
    </button>
  );
}
